import * as React from "react";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import Modal from "../../misc/components/modal";

export const ImportPermissions = ({ roleId, onClose }) => {
    const [selectedFile, setSelectedFile] = React.useState<File>();
    const legacyClient = useWebPortalLegacyClient();

    const onSaveClick = async () => {
        await legacyClient.importPermissionsApi(roleId, selectedFile);
        onClose();
    }

    return (
        <Modal show={true} header="Import Permissions to Role">
            <div className="row">
                <div className="col-md-12">
                    <div className="panel-body">
                        <div className="form-group">
                            <input type="file" className="form-control" onChange={(e) => setSelectedFile(e.target.files[0])} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button id="importButton" className="btn btn-primary" type="submit" disabled={false} onClick={onSaveClick}>
                    Import
                </button>&nbsp;
                <button id="returnToListButton" className="btn btn-primary btn-outline" onClick={onClose}>
                    Return to List
                </button>
            </div>
        </Modal>
    );
}
